var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconLooxr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629 629",
    enableBackground: "new 0 0 629 629",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M504.058,628.858H124.942c-68.925,0-124.8-55.875-124.8-124.8V124.942c0-68.925,55.875-124.8,124.8-124.8 h379.115c68.925,0,124.8,55.875,124.8,124.8v379.115C628.858,572.983,572.983,628.858,504.058,628.858z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vTKcx9.tif_1_",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#015B69",
    points: "-173.478,-12.142 2.876,204.403 -349.832,204.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005058",
    points: "-173.478,420.935 -349.832,204.403 2.876,204.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00505A",
    points: "-173.478,420.935 2.876,637.468 -349.832,637.468  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06958A",
    points: "2.876,637.468 179.23,420.935 -173.478,420.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#02887E",
    points: "2.876,204.403 -173.478,420.935 179.23,420.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#007878",
    points: "2.876,204.403 179.23,-12.142 -173.478,-12.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#017E7E",
    points: "179.23,420.935 2.876,637.468 355.584,637.468  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#007879",
    points: "179.23,420.935 355.584,204.403 2.876,204.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00797B",
    points: "179.23,-12.142 2.876,204.403 355.584,204.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06958A",
    points: "355.584,637.468 531.938,420.935 179.23,420.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00908F",
    points: "355.584,204.403 179.23,420.935 531.938,420.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#008188",
    points: "355.584,204.403 531.938,-12.142 179.23,-12.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005F62",
    points: "531.938,420.935 355.584,637.468 708.292,637.468  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00817E",
    points: "531.938,420.935 708.292,204.403 355.584,204.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0097AC",
    points: "531.938,-12.142 355.584,204.403 708.292,204.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#006969",
    points: "708.292,637.468 884.646,420.935 531.938,420.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#018A83",
    points: "708.292,204.403 531.938,420.935 884.646,420.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#01A3AD",
    points: "708.292,204.403 884.646,-12.142 531.938,-12.142  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M326.529,415.428c7.513,8.264,16.528,15.777,26.296,21.788c20.285,12.772,44.327,18.783,72.125,18.783 c26.296-0.751,49.586-6.762,69.872-19.534c20.285-12.021,36.063-29.301,47.333-51.089s16.528-46.581,16.528-74.379 c0-26.296-5.259-50.337-15.777-72.125c-10.518-21.037-26.296-38.316-46.581-51.089C476.791,175.011,452.749,169,424.951,169 c-165.287,0-103.68,242.672-214.873,242.672c-15.777,0-30.052-3.757-42.073-12.021s-21.037-19.534-27.798-34.56 c-6.762-15.026-9.767-31.554-9.767-51.089c0-19.534,3.757-37.565,11.27-52.591s17.28-27.047,29.301-35.311 s25.545-12.021,39.82-12.021c15.777,0,30.052,4.508,42.073,12.772s21.037,19.534,27.798,34.56 c0.751,2.254,1.502,4.508,2.254,6.762c6.762-20.285,15.026-40.571,24.041-59.353c-7.513-7.513-15.777-14.275-24.793-20.285 c-20.285-13.524-44.327-19.534-71.374-19.534c-26.296,0.751-49.586,6.762-69.872,19.534 c-20.285,12.021-36.063,29.301-47.333,51.089s-16.528,46.581-16.528,74.379c0,26.296,5.259,50.337,15.777,72.125 c10.518,21.037,26.296,38.316,46.581,51.089C159.739,449.989,183.781,456,211.579,456 c163.033-0.751,99.924-242.672,214.122-242.672c15.777,0,30.052,3.757,42.073,12.021c12.021,8.264,21.037,19.534,27.798,34.56 c6.761,15.026,9.767,31.554,9.767,51.089c0,19.535-3.757,37.565-11.27,52.591s-17.28,27.047-29.301,35.311 s-25.545,12.021-39.82,12.021c-15.777,0-30.052-4.508-42.073-12.772s-21.037-19.534-27.798-34.56 c-1.502-3.005-3.005-6.762-3.757-10.518C343.81,374.859,335.544,395.895,326.529,415.428z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconLooxr);
export default __webpack_public_path__ + "static/media/app_icon_looxr.c24c60efb3792dd31ed812c8d357b3a9.svg";
export { ForwardRef as ReactComponent };